import { render, staticRenderFns } from "./notReadNotifyDialog.vue?vue&type=template&id=20fad03d&scoped=true"
import script from "./notReadNotifyDialog.vue?vue&type=script&lang=ts"
export * from "./notReadNotifyDialog.vue?vue&type=script&lang=ts"
import style0 from "./notReadNotifyDialog.vue?vue&type=style&index=0&id=20fad03d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fad03d",
  null
  
)

export default component.exports